import { Injectable, Inject } from '@angular/core';
import { HttpModule, Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { APP_CONFIG, IAppConfig } from './../app.config';
import 'rxjs/add/observable/throw';

@Injectable()

export class DashboardService {

  private _token: string = localStorage.getItem('token');

  constructor(
    private http: Http,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) { }

  getTodoList$(): Observable<any> {
    const headers = new Headers({ 'Authorization': this._token });
    const options = new RequestOptions({ headers: headers });
    return this.http.get(this.config.apiEndpoint + 'dashboard/get-student-checklist-todo', options).map((res => res.json()))
    .catch(this.handleErrorObservable);
  }

  getCareerGoal$(): Observable<any> {
    const headers = new Headers({ 'Authorization': this._token });
    const options = new RequestOptions({ headers: headers });
    return this.http.get(this.config.apiEndpoint + 'dashboard/get-career-goals', options).map((res => res.json()))
    .catch(this.handleErrorObservable);
  }

  getCollagesApplied$(): Observable<any> {
    const headers = new Headers({ 'Authorization': this._token });
    const options = new RequestOptions({ headers: headers });
    return this.http.get(this.config.apiEndpoint + 'dashboard/get-collages-applied', options).map((res => res.json()))
    .catch(this.handleErrorObservable);
  }

  private handleErrorObservable (error: Response | any) {
    /*if(!error.json().error){
      alert('Please check your internet connection');
    }*/
    return Observable.throw( error.json().error || 'Server Error' );
  }
  
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/_services/dashboard.service.ts